import { useEffect, useState, type ReactNode } from 'react';

/**
 * Faqat brauzerda (mount bo'lgandan keyin) render qilinadigan qism — masalan Monaco.
 * Server va hydration renderida `fallback` chiziladi, shuning uchun markup mos keladi.
 */
export function ClientOnly({ children, fallback = null }: { children: ReactNode; fallback?: ReactNode }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return <>{mounted ? children : fallback}</>;
}
